import { forEach, isArray, isObject, snakeCase } from 'lodash';
import { toast } from 'react-toastify';

export const getErrorMessage = (error) => {
  if (error?.response?.data || error?.data || (error?.errors && error?.errors?.length)) {
    const errorObject =
      (error?.data && error?.data?.errorMessage) ||
      error?.response?.data?.message ||
      error?.response?.data?.errorMsg ||
      (Array.isArray(error?.response?.data?.errors) &&
        error?.response?.data?.errors?.length &&
        error?.response?.data?.errors[0]?.msg) ||
      error?.response?.data?.msg ||
      error?.response?.data ||
      error?.errors[0]?.msg ||
      'Something went wrong.';

    switch (typeof errorObject) {
      case 'object':
        return (
          errorObject?.msg ||
          JSON.stringify(errorObject.msg) ||
          errorObject?.data?.msg ||
          errorObject?.resp?.msg
        );
      case 'string':
        return errorObject;
      default:
        return 'Something went wrong.';
    }
  }
  return 'Something went wrong.';
};
export const toSnakeCase = (camel_case_object) => {
  var snakeCaseObject = {};
  forEach(camel_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return isObject(v) ? toSnakeCase(v) : v;
      });
    } else if (isObject(value)) {
      value = toSnakeCase(value);
    }
    snakeCaseObject[snakeCase(key)] = value;
  });
  return snakeCaseObject;
};

export const copyToClipboard = (text) => {
  const type = 'text/plain';
  const blob = new Blob([text], { type });
  const data = [new ClipboardItem({ [type]: blob })];
  try {
    navigator?.clipboard.write(data).then(() => {
      toast.info('Copied to Clipboard!');
    });
  } catch (error) {
    toast.error('Copying was unsuccessful!');
  }
};
